// src/components/ReasonSearchDropdown.js
import React, { useState, useRef, useEffect } from "react";
import { Box, TextField, Paper, List, ListItem, ListItemButton, Typography, Button } from "@mui/material";

const ReasonSearchDropdown = ({
  options,
  value,        // new: the currently selected label
  onSelect,
  onAddNew,
  onSearch
}) => {
  const [searchTerm, setSearchTerm] = useState(value || "");
  const [showOptions, setShowOptions] = useState(false);
  const containerRef = useRef(null);

  // keep searchTerm in sync when parent changes `value`
  useEffect(() => {
    setSearchTerm(value || "");
  }, [value]);

  const handleInputChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    setShowOptions(true);
    onSearch(term);
  };

  // click outside closes
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <Box ref={containerRef} sx={{ position: "relative", width: "100%", zIndex: 50 }}>
      <TextField
        placeholder="Reason"
        fullWidth
        value={searchTerm}
        onChange={handleInputChange}
        onFocus={() => setShowOptions(true)}
        variant="outlined"
      />

      {showOptions && (
        <Paper sx={{ position: "absolute", width: "100%", mt: 1 }}>
          <List dense sx={{ maxHeight: 160, overflowY: "auto" }}>
            {options.length > 0 ? options.map(opt => (
              <ListItem key={opt.ReasonID} disablePadding>
                <ListItemButton
                  onClick={() => {
                    onSelect(opt);
                    setSearchTerm(opt.Reason);
                    setShowOptions(false);
                  }}
                >
                  <Typography>{opt.Reason}</Typography>
                </ListItemButton>
              </ListItem>
            )) : (
              <ListItem>
                <Typography color="text.secondary">No results found</Typography>
              </ListItem>
            )}
          </List>
          <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
            <Button onClick={onAddNew} variant="contained" size="small">+ Add New</Button>
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default ReasonSearchDropdown;